import { loadStripe } from '@stripe/stripe-js'

const stripeKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY

// Only load Stripe if we have a real key (starts with pk_)
const isValidStripeKey = stripeKey && stripeKey.startsWith('pk_')
const stripePromise = isValidStripeKey ? loadStripe(stripeKey) : null

export default stripePromise